// Updated Dashboard.js
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Admin from "./Admin";
import UserTestPage from "../UserTest/UserTestPage";
import "./Dashboard.scss";

const Dashboard = () => {
  const [currentView, setCurrentView] = useState("dashboard");
  const [selectedTestId, setSelectedTestId] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const path = location.pathname;
    if (path.includes("/testpage") || path.includes("/test/")) {
      setCurrentView("test");
      const testIdMatch = path.match(/\/test\/(\d+)/);
      if (testIdMatch) {
        setSelectedTestId(parseInt(testIdMatch[1]));
      }
    } else if (path.includes("/results")) {
      setCurrentView("results");
    } else if (path.includes("/testconfig")) {
      setCurrentView("testconfig");
    } else {
      setCurrentView("dashboard");
    }
  }, [location.pathname]);

  const handleBackToDashboard = () => {
    setCurrentView("dashboard");
    setSelectedTestId(null);
    navigate("/dashboard", { replace: false });
  };

  const renderContent = () => {
    if (currentView === "test" && selectedTestId) {
      return (
        <UserTestPage testId={selectedTestId} onBack={handleBackToDashboard} />
      );
    }

    return <Admin />;
  };

  return <div className="">{renderContent()}</div>;
};

export default Dashboard;
